module.exports = __webpack_public_path__ + "vendors/solclient.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=vendors/solclient.js!./src/vendors/solclientjs/lib/solclient.js
// module id = 2500
// module chunks = 0